var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-news-wrapper"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.list),function(item,index){return _c('swiper-slide',{key:index,staticClass:"swiper-item",nativeOn:{"click":function($event){return _vm.gotodetail(item.id)}}},[_c('SmallNews',{attrs:{"data":item}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }